<section class="input">
  <app-autocomplete-3 [ctx]="autocompleteCtx"></app-autocomplete-3>

  <!--  <button (click)="add(); false" [class.active]="shouldClickOnAddBtn$ | async" [icon]="'PLUS_WHITE:14'"> </button>-->
</section>

<section class="tags">
  <div *ngFor="let value of values$ | async; index as i" class="tag">
    <button class="delete" (click)="delete(i); false">
      <!-- TODO: use [icon] directive -->
      <svg viewBox="0 0 8 8">
        <use href="#close"></use>
      </svg>
    </button>
    <span>{{ optionTitle(value) }}</span>
  </div>
</section>
